import locationCheckInHistoryService from '@/api/location-check-in-history-service';

export const initialCheckInHistoryFilterParams = () => ({});

const state = {
  checkInHistory: null,
  checkInHistoryPagination: {},
  checkInHistoryFilterParams: initialCheckInHistoryFilterParams(),
};

const mutations = {
  SET_CHECK_IN_HISTORY(state, { data, current_page, per_page, total }) {
    state.checkInHistory = data;
    state.checkInHistoryPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.checkInHistoryFilterParams = params;
  },
};

const actions = {
  fetchCheckInHistory({ state, commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return locationCheckInHistoryService.getPage(params).then((res) => {
      commit('SET_CHECK_IN_HISTORY', res.data);
      if (params.page !== state.checkInHistoryFilterParams.page) {
        window.scrollTo(0, 0);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
